// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"inviteUsersFormItem_checkboxLabel__3xrHw"};